// src/components/_v3/touristic-site/PracticalSection.jsx
import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {parseSchedule, scheduleRowLabel, getOpenStatus} from '../../../utils/touristic_sites/_v3/schedule';
import {Card, Eyebrow, SectionHead} from '../../../_ui/_v3/primitives';

const PratiqueGridStyled = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 1.2rem;

  @media (max-width: 820px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const PratiqueCardStyled = styled(Card)`
  padding: 1.1rem 1.3rem;
`;

const HoursListStyled = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: .05rem;

  li {
    display: flex;
    justify-content: space-between;
    padding: .5rem 0;
    border-bottom: 1px solid ${props => props.theme.colors.line};
    font-size: .88rem;
    color: ${props => props.theme.colors.inkSoft};
    font-variant-numeric: tabular-nums;
  }
  li:last-child { border-bottom: none; }
  li.today { font-weight: 700; color: ${props => props.theme.colors.ink}; }
`;

const StatusPillStyled = styled.span`
  display: inline-flex;
  align-items: center;
  gap: .35rem;
  font-weight: 700;
  font-size: .72rem;
  letter-spacing: .03em;
  text-transform: uppercase;
  margin-top: .8rem;
  color: ${props => props.open ? props.theme.colors.open : props.theme.colors.closed};

  .dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: currentColor;
  }
`;

const AccessTextStyled = styled.p`
  margin: 0;
  font-size: .88rem;
  color: ${props => props.theme.colors.inkSoft};
  white-space: pre-wrap;
`;

const FRENCH_DAYS = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
const isToday = (day) => FRENCH_DAYS[(new Date().getDay() + 6) % 7] === day.toLowerCase();

const PracticalSection = ({site}) => {
  const {t, i18n} = useTranslation(['touristic-site']);
  const rows = parseSchedule(site.schedule);
  const status = getOpenStatus(rows);
  const access = site.access_transport && (site.access_transport[`text_${i18n.language}`] || site.access_transport.text_fr);

  if (rows.length === 0 && !access) {
    return null;
  }
  return (
    <>
      <SectionHead>
        <Eyebrow>{t('v3.eyebrow.pratique')}</Eyebrow>
        <h2>{t('v3.section.pratique')}</h2>
      </SectionHead>
      <PratiqueGridStyled>
        {rows.length > 0 && (
          <PratiqueCardStyled>
            <HoursListStyled>
              {rows.map((row) => (
                <li key={row.day} className={isToday(row.day) ? 'today' : undefined}>
                  <span>{row.day}</span>
                  <span>{scheduleRowLabel(row.ranges) || '—'}</span>
                </li>
              ))}
            </HoursListStyled>
            {status && (
              <StatusPillStyled open={status === 'open'}>
                <span className="dot" />
                {t(`v3.status.${status}`)}
              </StatusPillStyled>
            )}
          </PratiqueCardStyled>
        )}
        {access && (
          <PratiqueCardStyled>
            <AccessTextStyled>{access}</AccessTextStyled>
          </PratiqueCardStyled>
        )}
      </PratiqueGridStyled>
    </>
  );
};

export default PracticalSection;
